import Program from "pages/dashboard/shared/TestManger/Program";
import { FC } from "react";

interface SchoolTestProgramProps {}

const SchoolTestProgram: FC<SchoolTestProgramProps> = () => {
  return <Program />;
};
export default SchoolTestProgram;
